module.exports = __webpack_public_path__ + "static/media/img2-2.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cebolla/nutricheck_foliar/FE/img2-2.png
// module id = 1379
// module chunks = 3